import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-center pb-4" }
const _hoisted_2 = { class: "my-8 md:my-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_surface_input = _resolveComponent("surface-input")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("Površina izbranih tlakovcev")), 1),
    _createVNode(_component_a_form, {
      ref: "formRef",
      model: _ctx.tiles
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles.entries(), ([i,tile]) => {
          return (_openBlock(), _createBlock(_component_surface_input, {
            key: tile,
            tile: tile,
            index: i
          }, null, 8, ["tile", "index"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}